import React from 'react';

interface ImageInsuranceProps {
  url: string;
  alt: string;
}

export default function ImageInsurance({ url, alt }: ImageInsuranceProps) {
  const [zoomIn, setZoomIn] = React.useState(false);
  const [failedToLoad, setFailedToLoad] = React.useState(false);
  const handleImageClick = () => {
    if (failedToLoad) return;
    setZoomIn((prevState) => !prevState);
  };
  const onLoadError = () => {
    setFailedToLoad(true);
  };
  const zoomCursor = zoomIn ? 'zoom-out' : 'zoom-in';
  const cursor = failedToLoad ? 'default' : zoomCursor;

  return (
    <div
      onClick={handleImageClick}
      style={{
        position: 'relative',
        cursor,
        width: failedToLoad ? '120px' : '340px',
        minHeight: failedToLoad ? '60px' : '200px',
        padding: '8px',
        zoom: zoomIn ? '150%' : '100%',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
        }}
      >
        <img onError={onLoadError} src={url} alt={alt} width="100%" height="100%" style={{ objectFit: 'fill' }} />
      </div>
    </div>
  );
}
